/**
 * Utility to generate consistent colors based on a string (e.g., UID).
 */

const PALETTE = [
  "#3b82f6", // Blue
  "#ef4444", // Red
  "#10b981", // Emerald
  "#f59e0b", // Amber
  "#6366f1", // Indigo
  "#ec4899", // Pink
  "#8b5cf6", // Violet
  "#14b8a6", // Teal
  "#f97316", // Orange
  "#06b6d4", // Cyan
];

/**
 * Returns a consistent hex color from the palette for a given string ID.
 * @param id The string ID (e.g., user UID)
 * @returns A hex color string
 */
export const getColorByUid = (id: string | undefined): string | null => {
  if (!id) return null;
  
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const index = Math.abs(hash) % PALETTE.length;
  return PALETTE[index];
};
